import axios from 'axios';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_PURCHASE_ORDERS_BY_FILTER,
  FETCH_PURCHASE_ORDERS_SUCCESS,
  FETCH_PURCHASE_ORDERS_FAILURE,
} from './type';

import {
  PURCHASE_URL,
} from './url';

import {
  ROOT_URL, ROOT_API_URL
} from './root_url';
const isEcity = (ROOT_API_URL === 'https://ct-scm.truckxi.com/api/') || (ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/');

export const deletePOImage = (imageid, success, failed) => {
  axios({
    method: 'DELETE',
    url: `${ROOT_URL}v1/purchase/po_images_delete/${imageid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      failed();
    })
}

export const fetchPOImages = (poid, success, failed) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v2/purchase/order/${poid}?depth=1`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      failed();
    })
}

export const savePOImages = (poid, images, success, failed) => {
  let data = new FormData();
  for (let i = 0; i < images.length; i++) {
    data.append('images', images[i].file[0]);
  }
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/purchase/upload_po_images/${poid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed();
    })
}

export const uploadPOPOD = (poid, formData, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/purchase/upload_pod_file/${poid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: formData,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed();
    })
}

export function fetchPurchaseOrdersByFilter(postingDateGT, postingDateLT, days, orderStatus, orderUser, searchProductNum) {
  let status = orderStatus;
  let user = orderUser;
  let productNum = searchProductNum;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status === 'all') {
    status = '';
  } else if (status === 'Partial') {
    status = '&PurchaseStatus=Partially%20Received';
  } else {
    status = `&PurchaseStatus=${status}`;
  }
  if (user) {
    user = isEcity ? `&vendor__default_purchaser_user_id=${user}` : `&Purchaser_User_id=${user}`;
  } else {
    user = '';
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }
  return (dispatch) => {
    dispatch({
      type: REQUEST_PURCHASE_ORDERS_BY_FILTER,
      payload: {
        dates,
        status,
        user,
        productNum,
      },
    });
  };
}

export const PurchaseOrderListEpic = action$ =>
  action$.ofType(REQUEST_PURCHASE_ORDERS_BY_FILTER)
    .switchMap(action =>
      axios.get(
        `${PURCHASE_URL}search/?OrderDate__gte=${action.payload.dates.fromDate
        }&OrderDate__lte=${action.payload.dates.toDate}${action.payload.status}${action.payload.user}${action.payload.productNum}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_PURCHASE_ORDERS_SUCCESS, payload: response }))
    .catch(err => ({ type: FETCH_PURCHASE_ORDERS_FAILURE, payload: err }));



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseOrderList_actions.jsx